import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables check:');
  console.warn('VITE_SUPABASE_URL:', supabaseUrl ? 'Present' : 'Missing');
  console.warn('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'Present' : 'Missing');
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key'
);

export interface Database {
  public: {
    Tables: {
      consultants: {
        Row: {
          id: string;
          email: string;
          name: string;
          created_at: string;
        };
        Insert: {
          id?: string;
          email: string;
          name: string;
          created_at?: string;
        };
        Update: {
          id?: string;
          email?: string;
          name?: string;
          created_at?: string;
        };
      };
      clients: {
        Row: {
          id: string;
          consultant_id: string;
          name: string;
          created_at: string;
        };
        Insert: {
          id?: string;
          consultant_id: string;
          name: string;
          created_at?: string;
        };
        Update: {
          id?: string;
          consultant_id?: string;
          name?: string;
          created_at?: string;
        };
      };
      vacancies: {
        Row: {
          id: string;
          client_id: string;
          title: string;
          vacancy_text: string;
          notes: string;
          shared: boolean;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          client_id: string;
          title: string;
          vacancy_text: string;
          notes?: string;
          shared?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          client_id?: string;
          title?: string;
          vacancy_text?: string;
          notes?: string;
          shared?: boolean;
          created_at?: string;
          updated_at?: string;
        };
      };
    };
  };
}
